/** Etiquetas romanas y nombres funcionales para enseñanza de escalas. */

const ROMAN: Record<string, string> = {
  R: "I",
  "1": "I",
  "2": "II",
  b2: "♭II",
  "3": "III",
  b3: "♭III",
  "4": "IV",
  "#4": "♯IV",
  "5": "V",
  b5: "♭V",
  "6": "VI",
  b6: "♭VI",
  "7": "VII",
  b7: "♭VII",
};

const FUNCTION_ES: Record<string, string> = {
  R: "Tónica",
  "2": "2ª",
  "3": "3ª",
  "4": "4ª",
  "5": "5ª",
  "6": "6ª",
  "7": "7ª",
  b3: "3ª ♭",
  b6: "6ª ♭",
  b7: "7ª ♭",
};

export function degreeRoman(degree: string): string {
  const d = degree.replace("*", "").trim();
  return ROMAN[d] ?? d;
}

export function degreeFunctionName(degree: string): string {
  const d = degree.replace("*", "").trim();
  return FUNCTION_ES[d] ?? `Grado ${d}`;
}

/** Texto corto sobre el pentagrama: romano + grado. */
export function staffDegreeCaption(degree: string): string {
  const d = degree.replace("*", "").trim();
  const roman = degreeRoman(d);
  return roman === d ? d : `${roman}`;
}
